import { PagePreferences } from './types';

export function groupByPageName(pages: PagePreferences[]): { [key: string]: PagePreferences } {
  const grouped: { [key: string]: PagePreferences } = {};
  pages.forEach(page => (grouped[page.id] = page));
  return grouped;
}
